import { closeModal } from "../../../ui/containers/Modal";
import { floodFill, lineDraw } from "../../../ui/helpers";
import { TextType } from "../../../ui/type/TextType";
import { bound, ComponentF, ComponentO, createElement } from "../../../ui/ui";
import { createAction } from "../../actions/Action";
import { wearArmor } from "../../actions/ActionItems";
import Colors from "../../Colors";
import { gameData, runPlayerAction } from "../../GameManager";
import { Item } from "../../items/Item";
import { isDownKey, isUpKey } from "../keyHelper";
import { drawArmorDetails, drawArmorText } from "./wearable/ArmorDisplay";

const Y_SPLIT = 12;

const getWearable = () => {
  const player = gameData.player;
  const items = player.contains.filter(
    (i) => i.breed.wearable != null
  ) as (Item | null)[];
  if (player.wearing.armor) {
    items.unshift(player.wearing.armor);
  }
  items.push(null);
  return items;
};

export const WearableModal: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C, props) => {
  const items = getWearable();
  const [state, setState] = C.useState({
    selected: gameData.player.wearing.armor?.id || (items[0] as Item).id || -1,
    wearing: gameData.player.wearing.armor?.id || -1,
  });

  floodFill(C.display, C.bounds, Colors.BLACK);
  let y = Y_SPLIT;

  lineDraw(
    C.display,
    bound(C.bounds, { x: 0, y: Y_SPLIT - 1, w: C.bounds.w, h: C.bounds.h }),
    "-"
  );

  const result: ComponentO[] = [];

  const wearing = state.wearing && items.find((i) => i?.id === state.wearing);
  if (wearing) {
    drawArmorText(C.display, wearing, C.bounds.x, C.bounds.y, 24);
    drawArmorDetails(
      C.display,
      wearing,
      C.bounds.x + 24,
      C.bounds.y,
      C.bounds.w - 24
    );
  } else {
    C.display.drawText(C.bounds.x, C.bounds.y, `Wearing: None`);
  }

  items.forEach((item) => {
    if (item == null) {
      if (state.selected == null) {
        result.push(
          createElement(TextType, { x: 0, y, w: 1, h: 1 }, { title: ">" })
        );
      }
      C.display.drawText(
        C.bounds.x + 1,
        C.bounds.y + y,
        `%c{${
          state.selected === null
            ? Colors.B_GREY_5
            : state.wearing === null
            ? Colors.RED_4
            : Colors.B_GREY_3
        }}None`,
        C.bounds.w - 24
      );
    } else if (item.breed.wearable) {
      if (state.selected === item.id) {
        result.push(
          createElement(TextType, { x: 0, y, w: 1, h: 1 }, { title: ">" })
        );
        const o = drawArmorText(
          C.display,
          item,
          C.bounds.x + 24,
          C.bounds.y + Y_SPLIT,
          24
        );
        drawArmorDetails(
          C.display,
          item,
          C.bounds.x + 24,
          C.bounds.y + Y_SPLIT + o,
          C.bounds.w - 24
        );
      }
      result.push(
        createElement(
          TextType,
          { x: 1, y, w: 30, h: 1 },
          {
            title: `%c{${
              state.selected === item.id
                ? Colors.B_GREY_5
                : state.wearing === item.id
                ? Colors.RED_4
                : Colors.B_GREY_3
            }}${item.breed.logName}${
              state.wearing === item.id ? " (Wearing)" : ""
            }`,
          }
        )
      );
      y += 1;
    }
  });

  C.display.drawText(
    C.bounds.x,
    C.bounds.y + C.bounds.h - 1,
    `%c{${Colors.RED_4}} Enter %c{}Select %c{${Colors.RED_4}}Esc%c{} Cancel`
  );

  C.handlers.keypress = (key: string) => {
    if (isUpKey(key)) {
      const idx = items.findIndex((i) => (i?.id || null) === state.selected);
      if (0 < idx) {
        setState({ selected: items[idx - 1]?.id || null });
      }
    } else if (isDownKey(key)) {
      const idx = items.findIndex((i) => (i?.id || null) === state.selected);
      if (idx < items.length - 1) {
        setState({ selected: items[idx + 1]?.id || null });
      }
    } else if (key === "Enter") {
      if (state.selected !== gameData.player.wearing.armor?.id) {
        runPlayerAction(
          createAction(wearArmor, gameData.player, {
            id: state.selected,
          })
        );
      }
      closeModal();
      return true;
    } else if (key === "Escape") {
      closeModal();
      return true;
    }
    return true;
  };
  return result;
};
